import { render, staticRenderFns } from "./sendDocumentOnMail.vue?vue&type=template&id=dca78ade&scoped=true"
import script from "./sendDocumentOnMail.vue?vue&type=script&lang=js"
export * from "./sendDocumentOnMail.vue?vue&type=script&lang=js"
import style1 from "./sendDocumentOnMail.vue?vue&type=style&index=1&id=dca78ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca78ade",
  null
  
)

export default component.exports